<template>
  <div class="searchContainer">
    <div class="flex breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-for="(item,index) in breadList" :key="index">{{item}}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button type="primary" v-if="showIcon"  :icon="'el-icon-plus'" circle size="mini"></el-button>
    </div>
    <el-collapse-transition>
      <div>
        <slot></slot>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
export default {
  props: {
    bread: {
      type: String,
      default: ''
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isShow: true
    }
  },
  computed: {
    breadList () {
      if (this.bread) {
        return this.bread.split(',')
      } else {
        return []
      }
    }
  },
  methods: {

  }
}
</script>

<style lang="scss">
  .searchContainer {
    .is-circle i {font-weight: bold;}
  }
</style>



// WEBPACK FOOTER //
// src/components/searchBarChocie.vue